import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
// Model imports
import { BlockIssuesResultDto } from './block-issues-result-dto';
import { ConveyanceClosingPaperCommunitiesResultDto } from './conveyance-closing-paper-communities-result-dto';
import { ConveyanceCommunityTransferAccountRawDto } from './conveyance-community-transfer-account-raw-dto';
import { ConveyanceOwnershipHistoryResultDto } from './conveyance-ownership-history-result-dto';
import { ConveyancePropertyInfoResultDto } from './conveyance-property-info-result-dto';
import { ConveyanceSellerInfoResultDto } from './conveyance-seller-info-result-dto';
const ɵ0 = () => ConveyancePropertyInfoResultDto, ɵ1 = () => ConveyanceSellerInfoResultDto, ɵ2 = () => ConveyanceOwnershipHistoryResultDto, ɵ3 = () => ConveyanceClosingPaperCommunitiesResultDto, ɵ4 = () => ConveyanceCommunityTransferAccountRawDto, ɵ5 = () => BlockIssuesResultDto;
export class ConveyanceWelcomeEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", ConveyancePropertyInfoResultDto)
], ConveyanceWelcomeEditorResultDto.prototype, "property", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", ConveyanceSellerInfoResultDto)
], ConveyanceWelcomeEditorResultDto.prototype, "seller", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], ConveyanceWelcomeEditorResultDto.prototype, "ownershipHistory", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], ConveyanceWelcomeEditorResultDto.prototype, "closingPaperCommunities", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", ConveyanceCommunityTransferAccountRawDto)
], ConveyanceWelcomeEditorResultDto.prototype, "conveyanceCommunityTransferAccount", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], ConveyanceWelcomeEditorResultDto.prototype, "blockIssues", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
